/* eslint-disable no-param-reassign */
import * as yup from 'yup';

export const createYupSchema = (schema, config, currentIndex) => {
  const {
    formSetting: { required, validator, extra },
  } = config;

  let validationType = 'string';
  if (validator === 'validateTxt') {
    validationType = 'string';
  }
  let yupValidator = yup[validationType]();

  if (validationType === 'string' && extra) {
    yupValidator.max([5, 'Max 50 tecken']);
  }

  if (required) {
    yupValidator = yupValidator.required(['Det här fältet är obligatoriskt']);
  }

  schema[`items.${currentIndex}`] = yupValidator;
  return schema;
};
